




























import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import {
  Ingredient,
  IngredientsDiff,
  ingredientsTotalAmount,
  ingredientsTotalPrice,
} from "@megarax/client/src/resources/plm/Ingredient";
import ResourceItemHyperlink from "@/components/resource/ResourceItemHyperlink";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";
import { DecimalStringInput } from "@/components/form/InputFields";
import {
  createComponent,
  ref,
  inject,
  computed,
  watch,
} from "@vue/composition-api";
import fileDownload from "js-file-download";
import ListUnitTable from "@/components/ListUnitTable.vue";
import { komponentResource } from "@megarax/client/src/resources/plm/Komponent";
import ResourceItemReference from "@/components/resource/ResourceItemReference";
import Decimal from "decimal.js";
import IngredientsTable from "./IngredientsTable.vue";

const ObjectsToCsv = require("objects-to-csv");

interface Props {
  value: Ingredient[];
  defaultAmount: number;
}

export default createComponent<Props>({
  components: {
    ResourceItemHyperlink,
    DecimalStringInput,
    ResourceItemReference,

    ListUnitTable,
    IngredientsTable,
  },
  filters: {},
  props: {
    value: {
      required: true,
    },
    defaultAmount: {
      default: 1000,
    },
  },
  setup(props, ctx) {
    const targetAmount = ref<Decimal>(new Decimal(1000));
    watch(
      () => props.defaultAmount,
      () => {
        targetAmount.value = new Decimal(props.defaultAmount);
      },
    );

    const sheetHighlights = inject(sheetOptionsSymbol, {} as SheetHighlights);

    const getRowClass = ({ row: ingredient }: { row: Ingredient }) => {
      const ingredientsHighlights = sheetHighlights["ingredients"];
      if (ingredientsHighlights)
        if (
          ingredientsHighlights === true ||
          ingredientsHighlights[ingredient.komponent!.id!]
        )
          return "table-warning";
    };

    async function onCsvButtonClick() {
      const data = props.value.map((skl: Ingredient) => ({
        komponent: skl.komponent!.str,
        "ilosc[g]": skl.massKg,
        "koszt[PLN]": skl.cost!.toFixed(2),
      }));

      const csv = new ObjectsToCsv(data);

      fileDownload(await csv.toString(), "składniki.csv");
    }

    return {
      getRowClass,
      komponentResource,
      onCsvButtonClick,
      targetAmount,
    };
  },
});
